export const isValidUrl = (url: string | undefined) => {
  if (url === undefined) return false;
  try {
    new URL(url);
    return true;
  } catch (e) {
    return false;
  }
};
